<template>
	<section class="monitoring__viewer">
		<div class="monitoring__column">
			<div class="monitoring__column_header">
				<h6 class="monitoring__column_title">
					<strong>Eventos Por Validar</strong>
				</h6>
				<span @click="loadEvents(true)" class="monitoring__column_refresh_icon"><v-icon>refresh</v-icon></span>
			</div>
			<div class="monitoring__events_container">
				<virtual-list class="monitoring__column_scroll" :data-key="'id'" :data-sources="events" :data-component="item"
					:page-mode="false" :bottom-threshold="10" :estimate-size="193" :keeps="15">
				</virtual-list>
			</div>
		</div>
		<transition name="fade" v-if="selectedData">
			<div style="width: 100%; height: 100%; overflow: auto; padding: 0 1rem 0 0.2rem;">
				<event-item :source="selectedData"></event-item>
				<h6 style="color: #006dc2; margin-bottom: 1rem;"><strong>Tarea realizada</strong></h6>
				<div style="display: flex; flex-direction: column;">
					<div class="monitoring__event_procedure--checkbox_group">
						<div v-for="(action, index) in event_list_actions" :key="index" :class="{
							'monitoring__event_procedure--checkbox': true,
							'checked': actionsBody.actionsTaken.includes(action.id),
							'active': true
						}" @click="toggleActionTaken(action.id)">
							<span class="material-icons" :class="'checkbox_' + action.color"
								:style="!actionsBody.actionsTaken.includes(action.id) ? 'background-color: transparent' : ''">
								{{ actionsBody.actionsTaken.includes(action.id) ? 'done' : '' }}
							</span>
							<p>
								{{ action.text }}
							</p>
						</div>
					</div>
					<textarea class="monitoring__event_procedure--textarea" placeholder="Comentarios..."
						v-model="actionsBody.comments">
					</textarea>
					<div style="display: flex; width: 100%; gap: 1.2rem; justify-content: flex-end; margin-top: 1rem;">
						<v-btn color="error" outlined
							:disabled="!(actionsBody.actionsTaken.length > 0 || actionsBody.comments.trim() !== '')"
							class="monitoring__event_procedure--action_button" @click="sendForm(false)">
							<v-icon
								:style="!(actionsBody.actionsTaken.length > 0 || actionsBody.comments.trim() !== '') ? 'border: 2px solid #c7c7c7' : 'border: 2px solid #ff5252;'"
								color="error" left>
								mdi-close
							</v-icon>
							Sin solucionar
						</v-btn>

						<v-btn :disabled="!(actionsBody.actionsTaken.length > 0 || actionsBody.comments.trim() !== '')"
							color="primary" class="monitoring__event_procedure--action_button"
							@click="sendForm(true)">
							<v-icon style="margin-right: 18px;"
								:style="!(actionsBody.actionsTaken.length > 0 || actionsBody.comments.trim() !== '') ? 'border: 2px solid #c7c7c7' : 'border: 2px solid #1C76D2;'"
								color="primary" left>
								mdi-check-bold
							</v-icon>
							Solucionado
						</v-btn>
					</div>

				</div>
			</div>
		</transition>
	</section>
</template>
<script>
import itemClickEventBus from '../../../services/eventBus';
import EventItem from './EventItem.vue';
import events_service from '../../../services/events_service';
export default {
	components: {
		// eslint-disable-next-line vue/no-unused-components
		EventItem,
	},
	data() {
		return {
			events: [],
			item: EventItem,
			selectedData: null,
			event_list_actions: [
				{ id: 1, text: "Llamada a Guarda", color: "primary" },
				{ id: 2, text: "Llamar a Policía", color: "alert" },
				{ id: 3, text: "Llamada al Cliente", color: "primary" },
				{ id: 4, text: "Intrusión", color: "alert" },
				{ id: 5, text: "CCTV Verificado", color: "primary" },
				{ id: 6, text: "Envío Supervisor", color: "alert" },
				{ id: 7, text: "Ronda Guarda", color: "primary" },
				{ id: 8, text: "Falsa alarma", color: "success" },
				{ id: 9, text: "Usuario identificado", color: "primary" },
				{ id: 10, text: "Falsa alarma - Mascota", color: "success" },
				{ id: 11, text: "Falla Energía/Internet", color: "success" },
			],
			actionsBody: {
				comments: '',
				actionsTaken: [],
			}
		};
	},
	mounted() {
		this.subscribeToUpdateChannel();
		const self = this;
		itemClickEventBus.$on('item_click', (data) => {
			self.selectedData = {
				...data,
				emitEvent: false,
				showCroppedPhoto: true,
			}
		});
		this.loadEvents();
	},
	beforeDestroy() {
		this.unsubscribeFromUpdateChannel();
		itemClickEventBus.$off('item_click');
	},
	methods: {
		subscribeToUpdateChannel() {
			this.$cable.subscribe({
				channel: 'FaceNotificationsValidatorChannel',
				company_id: this.getSelectedCompany(),
				user_id: this.getUserId()
			});
			console.log(this.$cable)
		},
		unsubscribeFromUpdateChannel() { 
			this.$cable.unsubscribe();
		},
		loadEvents(reload = false) {
			if (this.isLoading) return;
			this.isLoading = true;
			const self = this;
			if (reload) this.lastRecordId = undefined;
			events_service.getPendingValidations({
				user_id: this.getUserId(),
				company_id: this.getSelectedCompany(),
			},
				{
					'X-Device-ID': this.getDeviceId(),
				}
			).then(response => {
				//TODO: validate and group events

				self.lastRecordId = response.data.last_record_id;

				const events = [];

				const locations = this.getMonitoredCompanies().find(e => e.id === this.getSelectedCompany()).monitored_locations;

				response.data.pairs.forEach(item => {
					const firstLocation = locations.find(loc => loc.id === item.event_1.location_id);

					const id = `${item.event_1.id}_${item.event_2.id}`;

					events.push({
						id,
						event_time: item.event_1.event_time ?? item.event_1.created_at,
						camera1: item.event_1,
						camera2: item.event_2,
						location_name: firstLocation?.name ?? 'not location',
						emitEvent: true,
						showLocation: true,
					});
				});

				response.data.singles.forEach(event => {
					const loc = locations.find(item => item.id === event.location_id);
					const id = `${event.id}_${event.id}`;

					events.push({
						id,
						event_time: event.event_time ?? event.created_at,
						camera1: event,
						camera2: event,
						location_name: loc?.name ?? 'not location',
						emitEvent: true,
						showLocation: true,
					});
				});

				self.events = events;

			}).finally(() => {
				self.isLoading = false;
			})
		},
		toggleActionTaken(action) {
			const index = this.actionsBody.actionsTaken.indexOf(action);
			if (index !== -1) {
				this.actionsBody.actionsTaken.splice(index, 1);
				return;
			} else {
				this.actionsBody.actionsTaken.push(action);
			}
		},
		async sendForm(solved) {
			const actions = this.event_list_actions.filter(item => this.actionsBody.actionsTaken.includes(item.id)).map(item => item.text);
			const data = {
				event_ids: [this.selectedData.camera1.id, ], //add camera 2 id
				location_id: this.selectedData.camera1.location_id,
				review_comment: `${this.actionsBody.comments}|${actions.join('|')}`,
				event_solved: solved,
				user_id: this.getUserId(),
			};
			try {
				await events_service.proccessEvent({
					data: this.encrypt(data).toString(),
				});
				this.loadEvents(true);
				this.resetForm();
				
			} catch(err) {
				console.error(err);
			}
		},
		resetForm() {
			this.actionsBody = {
				actionsTaken: [],
				comments: '',
			};
			this.selectedData = null;
		}
	},
	channels: {
		FaceNotificationsValidatorChannel: {
			connected() {
				console.log('connected')
			},
			received(data) {
				if (data) {
					this.loadEvents();
				}
			}
		}
	}

}
</script>

data: [
{
	
}
]